
import { getAracTypes } from "../../../../../features/adminSett/adminSettSlice"
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import textFilter from "../../../../../helper/textFilter"
import {MdKeyboardArrowRight} from "react-icons/md"
import { handleActiveSelect } from "../../../../../features/layout/layoutSlice"
import { updateAracData } from "../../../../../features/addLoad/addLoadSlice"

const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }

`

const AracTuruInput = ({data, name, isRequired, labelText="Araç Türü"}) => {

    const [text, setText] = useState(data?.aracTypeName)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)
    const {aracTypes} = useSelector(state => state.adminSett)
    const {showErrors, showRequiredPlaces} = useSelector(state => state.addLoad)
    const [isError, setIsError] = useState(false)
    const [options, setOptions] = useState([])

    useEffect(() => {
        if(aracTypes){
            setOptions(aracTypes)
        }
    },[aracTypes])
    
    

    useEffect(()=> {
        setText(data.aracTypeName)
    },[data.aracTypeName])


    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(aracTypes)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(aracTypes, searchText, "name")
            setOptions(result)
        }

        setText(searchText)
    }

    const handleOptionClick = (item) => {

        //! burada arac türü değişmişse kasa turunu sıfırla
        if(item?.name !== data?.aracTypeName){
            dispatch(updateAracData({kasaTypeName: "", kasaTypeId: ""}))
        }
        dispatch(updateAracData({aracTypeName: item?.name, aracTypeId:item?.id,  kasaTypeOptions: item?.trailerTypesModel?.$values}))
        setText(item?.name)
        dispatch(handleActiveSelect(null))
    }


    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data?.aracTypeName && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data?.aracTypeName, showRequiredPlaces, showErrors])

    //! active olan item ın arka planını hafif sarı yaparsın

  return (
    <Container onClick={(e)=>e.stopPropagation()} value={text} radius={"5px"} isActive={activeSelect === name} isError={isError}>

        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && " (Zorunlu)"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options?.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item?.name}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default AracTuruInput